import type { BotIdTags } from "@homeinstead/analytics";

// Default tags when BotID classification is unavailable. We intentionally do
// not set `botid_human: true` here so dashboards can distinguish a real
// human verification from a fallback after a BotID failure.
const FALLBACK_BOTID_TAGS: BotIdTags = {
  botid_bot: false,
  botid_goodbot: false,
  botid_human: false,
};

export { FALLBACK_BOTID_TAGS };
